import { HereLayer } from "common/utils/MapMarker/types";
import { useMemo } from "react";
import { getStationIcon } from "../utills";
import { getCarIcon } from "features/cars/CarEBoxLocations/utils";
import { getClientEventTitleIcon } from "../utills/clientEventHistoryIcon/getClientEventTitleIcon";
import {
  useClientEventsHistoryFilter,
  useClientFuelHistoryEvents,
} from "entities/navigation";

export const useClientFuelHistoryEventsMarkersLayer = () => {
  const clientEventsHistory = useClientFuelHistoryEvents();
  const clientEventFilter = useClientEventsHistoryFilter();

  const data = useMemo(
    () =>
      clientEventFilter.length > 0
        ? clientEventsHistory.filter(({ type }) => clientEventFilter.includes(type))
        : clientEventsHistory,
    [clientEventFilter, clientEventsHistory]
  );

  const clientHistoryEventsMarkersLayer = useMemo(
    (): HereLayer => ({
      data,
      name: "client-fuel-history-events",
      type: "marker",
      getCoordinates: ({
        data: {  longitude, latitude  }
      }) => ({
        latitude,
        longitude
      }),
      getIcon: ({ clusterWeight = 0, data }) => {
        if (clusterWeight) {
          const { url, width, height } = getCarIcon({
            properties: {
              cluster: true,
              point_count: clusterWeight,
            },
          });

          return {
            url,
            width,
            height,
            anchorY: height,
            anchorX: width / 2
          };
        }

        const { url, height, width } = getStationIcon();

        return {
          url,
          width,
          height,
          anchorY: height,
          anchorX: width / 2
        };
      }
    }),
    [data]
  );

  return clientHistoryEventsMarkersLayer;
};

export const useClientFuelHistoryEventsTitleMarkersLayer = () => {
  const clientEventsHistory = useClientFuelHistoryEvents();
  const clientEventFilter = useClientEventsHistoryFilter();
  const data = useMemo(
    () =>
      clientEventFilter.length > 0
        ? clientEventsHistory.filter(({ type }) => clientEventFilter.includes(type))
        : clientEventsHistory,
    [clientEventFilter, clientEventsHistory]
  );

  const clientHistoryEventsMarkersLayer = useMemo(
    (): HereLayer => ({
      data,
      name: "client-history-events-title",
      type: "marker",
      getCoordinates: ({
        data: {  longitude, latitude }
      }) => ({
        latitude,
        longitude
      }),
      getIcon: ({ clusterWeight, data }) => {
        if (clusterWeight) {
          const { url, width, height } = getCarIcon({
            properties: {
              cluster: true,
              point_count: clusterWeight,
            },
          });

          return {
            url,
            width,
            height,
            anchorY: height,
            anchorX: width / 2
          };
        }

        const { url, height, width } = getClientEventTitleIcon({
          stationCode: data.stationUid,
          serviceTitle: data.serviceTitle,
          totalPrice: data.clientAmount,
          currency: data.clientCurrency,
          date: data.date,
          litersAmount: data.volume
        });

        return {
          url,
          width,
          height,
          anchorY: height * 1.3,
          anchorX: width / 2.1,
          id: data.stationUid
        };
      }
    }),
    [data]
  );

  return clientHistoryEventsMarkersLayer;
};
